import { render } from "./BookmarkNav.vue?vue&type=template&id=33601c4c&scoped=true"
import script from "./BookmarkNav.vue?vue&type=script&lang=js"
export * from "./BookmarkNav.vue?vue&type=script&lang=js"

import "./BookmarkNav.vue?vue&type=style&index=0&id=33601c4c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33601c4c"]])

export default __exports__